Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Iframe = void 0;

var self_1 = require("./self");

var iframe_reset_1 = require("./iframe-reset");

exports.Iframe = function (props) {
  return self_1.getSelf(props, iframe_reset_1.iframeReset, 'iframe', props.iframeProps);
};